exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3S73g{margin:0 auto}._2Ky7J{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3zgMy{position:relative}.f7n4g>div{margin-bottom:0}.f7n4g>div>div{padding-top:10px;margin-bottom:20px}.f7n4g{position:relative;margin-bottom:0;background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:justify;align-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}._1pTw9{width:calc(100% - 300px);padding-right:20px}._3ffsz{background-color:#fff;border-bottom:1px solid #e0e0e0;border-radius:2px 2px 0 0}._3hmQe{margin:0;padding-left:0}._2wDaI{position:relative}._2wDaI,._9vdC9{display:inline-block}._9vdC9{text-decoration:none;font-weight:400;font-size:12px;padding:15px 14px 9px;border-bottom:4px solid transparent;cursor:pointer;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;text-transform:uppercase;letter-spacing:.1em}._9vdC9:hover{color:#e73232;border-bottom:4px solid #ffd906}.LqqnO{position:relative}.LqqnO ._9vdC9{color:#000;font-weight:700;border-bottom:4px solid #ffd906}._1rvEr{background-color:#fff;border-radius:2px 2px 0 0;border-bottom:1px solid #e0e0e0}.qHTIU{margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"page": "_1hirf page",
	"container": "_3S73g container",
	"flexRow": "_2Ky7J flexRow",
	"flexCell": "_3zgMy",
	"advertContainer": "f7n4g",
	"mainCell": "_1pTw9",
	"navWrapper": "_3ffsz",
	"list": "_3hmQe",
	"item": "_2wDaI",
	"link": "_9vdC9",
	"active": "LqqnO",
	"header": "_1rvEr",
	"advertContainerGl": "qHTIU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/dealer/Dealer.css
// module id = 3052
// module chunks = 15